import Share from 'ninelines-sharing';

$('[data-social]').on('click', (e) => {
	const social = $(e.currentTarget).data('social');
	let url = location.origin + location.pathname;

	if (location.hash) {
		url += `${url[url.length - 1] === '/' ? '' : '/'}share.php?screen=${location.hash.substring(1)}`;
	}

	Share[social](url);
});
